import { Any, JsonObject, JsonProperty } from 'json2typescript';

import { Account } from './account';
import { Dept } from '../tenant/dept';
import { Group } from '../tenant/group';
import { Position } from './position';
import { Tenant } from '../tenant/tenant';

/**
 * ç¨æ·ä¿¡æ¯
 */
@JsonObject
export class User {
  /**
   * è´¦æ·ä¿¡æ¯
   */
  @JsonProperty('account', Account)
  account: Account = undefined;

  /**
   * æç®¡ççç§å®¤åè¡¨
   */
  @JsonProperty('depts', [Dept])
  depts: Dept[] = undefined;

  /**
   * æç®¡ççå°ç»åè¡¨
   */
  @JsonProperty('groups', [Group])
  groups: Group[] = undefined;

  /**
   * ä¸ªäººä¿¡æ¯
   */
  @JsonProperty('me', Any)
  me: any;

  /**
   * èä½ä¿¡æ¯
   */
  @JsonProperty('position', Position)
  position: Position = undefined;

  /**
   * æå±å»é¢ä¿¡æ¯
   */
  @JsonProperty('tenant', Tenant)
  tenant: Tenant = undefined;

}
